// SkipToContent.js — themed to match GoGameDev3D dark/indigo aesthetic
import React from 'react';

const SkipToContent = () => {
  return (
    <>
      <style>{`
        .skip-to-content {
          position: absolute;
          top: -120px;
          left: 50%;
          transform: translateX(-50%);
          background: linear-gradient(135deg, #6366f1, #4f46e5);
          color: white;
          padding: 12px 28px;
          text-decoration: none;
          border-radius: 0 0 12px 12px;
          font-weight: 700;
          font-size: 0.95rem;
          z-index: 10000;
          transition: top 0.3s cubic-bezier(0.4,0,0.2,1);
          box-shadow: 0 8px 24px rgba(99,102,241,0.5);
          letter-spacing: 0.01em;
          white-space: nowrap;
        }
        .skip-to-content:focus {
          top: 0;
        }
        .skip-to-content:hover {
          background: linear-gradient(135deg, #4f46e5, #4338ca);
        }
        .skip-to-content:focus-visible {
          outline: 3px solid #a5b4fc;
          outline-offset: 2px;
        }
      `}</style>

      <a
        href="#main-content"
        className="skip-to-content"
        aria-label="דלג לתוכן הראשי"
      >
        דלג לתוכן הראשי ↓
      </a>
    </>
  );
};

export default SkipToContent;